import Home from '../../components/core/pages/Home';
import BuyTracker from '../../components/module/BuyTracker/BuyTracker';
import Reporting from '../../components/module/Reporting/Reporting';
import AccountSettings from '../../components/core/pages/AccountSettings';
import ItemCard from '../../components/module/ItemCard/ItemCard';
import PowerScan from '../../components/core/pages/PowerScan';
import ReceiveAtElevator from '../../components/core/pages/PowerScan/ReceiveAtElevator';
import BoxReceive from '../../components/core/pages/PowerScan/BoxReceive';
import XferToBinLocation from '../../components/core/pages/PowerScan/XferToBinLocation';
import XferToSite from '../../components/core/pages/PowerScan/XferToSite';
import PickLists from '../../components/core/pages/PowerScan/PickLists';
import PickByBin from '../../components/core/pages/PowerScan/PickByBin';
import BinMovement from '../../components/core/pages/PowerScan/BinMovement';
import Settings from '../../components/core/pages/PowerScan/Settings';

export const routerConfig = {
  mode: 'history',
  routes : [
    {
      path: '/',
      name: 'Home',
      redirect: 'power-scan',
      component: Home,
      meta: {
        breadcrumb : [
          { name: 'Home' },
        ]
      },
    },
    {
        path: '/buy-tracker',
        name: 'BuyTracker',
        component: BuyTracker,
        meta: {
            activeModule:'BuyTracker',
            breadcrumb : [
                { name: 'Home', link: '/' },
                { name: 'Buy Tracker' },
                { name: 'Item Listing' }
            ],
            subModules: [
                { name:'ItemListing', link: '/buy-tracker/item-list'},
                { name: 'BoxListing', link: '/buy-tracker/box-list'},
                { name: 'ReceiptListing', link: '/buy-tracker/receipt-list'}
            ]
        },
    },
    {
        path: '/buy-tracker/item-list',
        name: 'ItemListing',
        component: BuyTracker,
        meta: {
          breadcrumb : [
            { name: 'Home', link: '/' },
            { name: 'Buy Tracker' },
            { name: 'Item Listing' }
          ],
          activeModule:'BuyTracker',
          activeSubModule: 'ItemListing',
          title:'List Item',
          subModules: [
            { name:'ItemListing', link: '/buy-tracker/item-list'},
            { name: 'BoxListing', link: '/buy-tracker/box-list'},
            { name: 'ReceiptListing', link: '/buy-tracker/receipt-list'}
          ]
        },
    },
    {
        path: '/buy-tracker/receipt-list',
        name: 'ReceiptListing',
        component: BuyTracker,
        meta: {
          breadcrumb : [
            { name: 'Home', link: '/' },
            { name: 'Buy Tracker' },
            { name: 'Receipt Listing' }
          ],
          activeModule:'BuyTracker',
          activeSubModule: 'ReceiptListing',
          title:'List Receipt',
          subModules: [
            { name:'ItemListing', link: '/buy-tracker/item-list'},
            { name: 'BoxListing', link: '/buy-tracker/box-list'},
            { name: 'ReceiptListing', link: '/buy-tracker/receipt-list'}
          ]
        },
    },
    {
        path: '/buy-tracker/box-list',
        name: 'BoxListing',
        component: BuyTracker,
        meta: {
          breadcrumb : [
            { name: 'Home', link: '/' },
            { name: 'Buy Tracker' },
            { name: 'Box Listing' }
          ],
          activeModule:'BuyTracker',
          activeSubModule: 'BoxListing',
          title:'List Boxes',
          subModules: [
            { name: 'ItemListing', link: '/buy-tracker/item-list'},
            { name: 'BoxListing', link: '/buy-tracker/box-list'},
            { name: 'ReceiptListing', link: '/buy-tracker/receipt-list'}
          ]
        },
    },
    {
        path: '/buy-tracker/item-create',
        name: 'ItemCreate',
        component: BuyTracker,
        meta: {
          breadcrumb : [
            { name: 'Home', link: '/' },
            { name: 'Buy Tracker' },
            { name: 'Item Listing' },
            { name: 'Create Item' }
          ],
          activeModule:'BuyTracker',
          activeSubModule: 'ItemListing',
          title:'Create an Item',
          subModules: [
            { name:'ItemListing', link: '/buy-tracker/item-list'},
            { name: 'BoxListing', link: '/buy-tracker/box-list'},
            { name: 'ReceiptListing', link: '/buy-tracker/receipt-list'}
          ]
        },
    },
    {
        path: '/buy-tracker/box-create',
        name: 'BoxCreate',
        component: BuyTracker,
        meta: {
          breadcrumb : [
            { name: 'Home', link: '/' },
            { name: 'Buy Tracker' },
            { name: 'Box Listing' },
            { name: 'Create Box' }
          ],
          activeModule:'BuyTracker',
          activeSubModule: 'BoxListing',
          title:'Create a Box',
          subModules: [
            { name:'ItemListing', link: '/buy-tracker/item-list'},
            { name: 'BoxListing', link: '/buy-tracker/box-list'},
            { name: 'ReceiptListing', link: '/buy-tracker/receipt-list'}
          ]
        },
    },
    ,
    {
        path: '/buy-tracker/receipt-create',
        name: 'ReceiptCreate',
        component: BuyTracker,
        meta: {
          breadcrumb : [
            { name: 'Home', link: '/' },
            { name: 'Buy Tracker' },
            { name: 'Receipt Listing' },
            { name: 'Create Receipt' }
          ],
          activeModule:'BuyTracker',
          activeSubModule: 'ReceiptListing',
          title:'Create a Receipt',
          subModules: [
            { name:'ItemListing', link: '/buy-tracker/item-list'},
            { name: 'BoxListing', link: '/buy-tracker/box-list'},
            { name: 'ReceiptListing', link: '/buy-tracker/receipt-list'}
          ]
        },
    },
    {
        path: '/reporting',
        name: 'Reporting',
        component: Reporting,
        meta: {
          activeModule:'Reporting',
          breadcrumb : [
            { name: 'Home', link: '/' },
            { name: 'Reporting' },
          ]
        },
    },
    {
        path: '/power-scan',
        name: 'PowerScan',
        component: PowerScan,
        meta: {
          activeModule:'PowerScan',
          breadcrumb : [
            { name: 'Home', link: '/' },
            { name: 'PowerScan' },
          ]
        },
    },
    {
        path: '/power-scan/receive-at-elevator',
        name: 'ReceiveAtElevator',
        component: ReceiveAtElevator,
        meta: {
          activeModule:'PowerScan',
          breadcrumb : [
            { name: 'Home', link: '/' },
            { name: 'PowerScan', link: '/power-scan' },
            { name: 'Receive at the Elevator' },
          ]
        },
    },
    {
        path: '/power-scan/box-receive',
        name: 'BoxReceive',
        component: BoxReceive,
        meta: {
          activeModule:'PowerScan',
          breadcrumb : [
            { name: 'Home', link: '/' },
            { name: 'PowerScan', link: '/power-scan' },
            { name: 'Box Receive' },
          ]
        },
    },
    {
        path: '/power-scan/xfer-to-bin-location',
        name: 'XferToBinLocation',
        component: XferToBinLocation,
        meta: {
          activeModule:'PowerScan',
          breadcrumb : [
            { name: 'Home', link: '/' },
            { name: 'PowerScan', link: '/power-scan' },
            { name: 'Xfer Items to Bin/Location' },
          ]
        },
    },
    {
        path: '/power-scan/xfer-to-site',
        name: 'XferToSite',
        component: XferToSite,
        meta: {
          activeModule:'PowerScan',
          breadcrumb : [
            { name: 'Home', link: '/' },
            { name: 'PowerScan', link: '/power-scan' },
            { name: 'Xfer Items to a Site' },
          ]
        },
    },
    {
        path: '/power-scan/pick-lists',
        name: 'PickLists',
        component: PickLists,
        meta: {
          activeModule:'PowerScan',
          breadcrumb : [
            { name: 'Home', link: '/' },
            { name: 'PowerScan', link: '/power-scan' },
            { name: 'Pick Lists' },
          ]
        },
    },
    {
        path: '/power-scan/pick-by-bin',
        name: 'PickByBin',
        component: PickByBin,
        meta: {
          activeModule:'PowerScan',
          breadcrumb : [
            { name: 'Home', link: '/' },
            { name: 'PowerScan', link: '/power-scan' },
            { name: 'Pick By Bin' },
          ]
        },
    },
    {
        path: '/power-scan/bin-movement',
        name: 'BinMovement',
        component: BinMovement,
        meta: {
          breadcrumb : [
            { name: 'Home', link: '/' },
            { name: 'PowerScan', link: '/power-scan' },
            { name: 'Bin Movement' },
          ]
        },
    },
    {
        path: '/power-scan/settings',
        name: 'Settings',
        component: Settings,
        meta: {
          activeModule:'PowerScan',
          breadcrumb : [
            { name: 'Home', link: '/' },
            { name: 'PowerScan', link: '/power-scan' },
            { name: 'Settings' },
          ]
        },
    },

    {
      path: '/account-settings',
      name: 'AccountSettings',
      component: AccountSettings,
      meta: {
        breadcrumb : [
          { name: 'Home', link: '/' },
          { name: 'PowerScan', link: '/account-settings' },
        ]
      },
    },

    {
      path: '/item-card',
      name: 'ItemCard',
      component: ItemCard,
      meta: {
        activeModule:'ItemCard',
        breadcrumb : [
          { name: 'Home', link: '/' },
          { name: 'Item Card' },
        ]
      },
    },

  ]
}
